import LatestFiles from "@components/dashboard/latest-files"
import DashboardLayout from "@pma/app/dashboard/layout"
import LatestNotes from "@components/dashboard/latest-notes"
import LatestTasks from "@components/dashboard/latest-task"
import ProjectsTable from "@components/projects/projects-table"
import PinnedTasks from "@pma/components/dashboard/pinned-tasks"
import PinnedProjects from "@pma/components/dashboard/pinned-projects"
import { ProjectProvider } from "@pma/contexts/ProjectContext"
import Joyride, { Step } from "react-joyride"
import { useEffect, useState } from "react"
import { useAuth } from "@pma/stores/auth-store"
import axios from "axios"
import { SERVER_URL, SET_TOUR_VIEW } from "@pma/utils/api-routes"
import { ACCESS_TOKEN } from "@pma/utils/constants"
import { parseCookies } from "nookies"
import { useMutation } from "@tanstack/react-query"
import useTranslator from "@pma/hooks/use-translator"

const HomePage = () => {
  const { authConfig, signIn } = useAuth()
  const accessToken = parseCookies()[ACCESS_TOKEN]
  const { translate } = useTranslator()

  const [isTourOpen, setIsTourOpen] = useState(false)

  useEffect(() => {
    const hasVisited = authConfig?.tour_is_viewed || false
    if (hasVisited == false) setIsTourOpen(true)
  }, [])

  const handleSetTourView = async () => {
    const response = await axios.post(
      SERVER_URL + SET_TOUR_VIEW,
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    )
    return response
  }

  const tourViewMutation = useMutation({
    mutationKey: ["tour-view"],
    mutationFn: handleSetTourView,
    onSuccess: (data) => signIn({ ...authConfig, tour_is_viewed: true }),
    onError: (error) => signIn({ ...authConfig, tour_is_viewed: false }),
  })

  const steps: Step[] = [
    {
      target: "#app-logo",
      content: translate("This is the app logo. Clicking on it will take you back to the homepage."),
      placement: "bottom",
    },
    {
      target: "#sidebar-navigation",
      content: translate("This is the sidebar navigation panel, where you can navigate through different sections of the app."),
      placement: "right",
    },
    {
      target: "#user-profile-section",
      content: translate("Here is your profile section, where you can view and update your personal details."),
      placement: "top",
    },
    {
      target: "#account-settings-button",
      content: translate("Click here to access and manage your account settings."),
      placement: "left",
    },
  ]
  return (
    <>
      <Joyride
        steps={steps}
        continuous={true}
        showSkipButton={true}
        showProgress={true}
        run={isTourOpen}
        callback={(data) => {
          if (
            data.type !== "error:target_not_found" &&
            (data.status === "finished" || data.status === "skipped")
          ) {
            setIsTourOpen(false)
            tourViewMutation.mutate()
          }
        }}
        locale={{
          back: translate("Back"),
          close: translate("Close"),
          last: translate("End Tour"),
          next: translate("Next"),
          skip: translate("Skip"),
        }}
      />
      <DashboardLayout>
        <ProjectProvider defaultPageSize={20}>
          <>
            <PinnedProjects />
            <PinnedTasks />
            <ProjectsTable sm />
            <div className='grid grid-cols-1 gap-y-7 pb-6 md:grid-cols-2 md:gap-3 lg:grid-cols-3'>
              <LatestFiles />
              <LatestTasks />
              <LatestNotes />
            </div>
          </>
        </ProjectProvider>
      </DashboardLayout>
    </>
  )
}

export default HomePage
